import { type hr as cpt } from 'efd-cpt-backend-interfaces-ts'

export type ReplaceDateWithStringType<T> = {
  [P in keyof T]: T[P] extends Date ? string : T[P]
}
export type VehicleDTO =
  ReplaceDateWithStringType<cpt.emilfreydigital.customer_portal_backend.rest.vehicle.dto.VehicleDTO>
export type VehicleSpecsDTO =
  ReplaceDateWithStringType<cpt.emilfreydigital.customer_portal_backend.rest.vehicles.dto.VehicleSpecsDTO>
export type VehicleDealersDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicle.dto.VehicleDealersDTO
export type DealerDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.dealer.dto.DealerDTO
export type LoanDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicle.dto.LoanDTO
export type LoanType =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicle.dto.LoanType
export type imgType = 'brandlogo' | 'vehicleimage'
export type BrandDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicle.dto.BrandDTO

export type VehicleLoanDto =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicle_loan.dto.VehicleLoanDto

export type OwnershipResponseDto =
  ReplaceDateWithStringType<cpt.emilfreydigital.customer_portal_backend.rest.ownership.dto.OwnershipResponseDto>
export type OwnershipListResponseDto =
  cpt.emilfreydigital.customer_portal_backend.rest.ownership.dto.OwnershipListResponseDto

export type OwnershipCreateResponse =
  ReplaceDateWithStringType<cpt.emilfreydigital.customer_portal_backend.rest.ownership.dto.OwnershipCreateResponseDto>
export type OwnershipCreateRequest =
  cpt.emilfreydigital.customer_portal_backend.rest.ownership.dto.OwnershipDto
export type OwnershipDriverDto =
  cpt.emilfreydigital.customer_portal_backend.client.customer_profile.dto.ownership.OwnershipDriverDTO

export enum VehicleStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface NewVehicleDTO extends Omit<VehicleDTO, 'details' | 'loan' | 'fuelType'> {
  details?: VehicleSpecsDTO
  loan?: VehicleLoanDto
}

interface VehicleDTOExtension {
  dealers?: VehicleDealersDTO
  dealer?: DealerDTO
  brandPicture?: string
  pictureType?: imgType
  active?: boolean
  requestedForRemoval?: boolean
}

export interface LegacyVehicleDTOExtended
  extends VehicleDTO, VehicleDTOExtension {}

export interface VehicleDTOExtended
  extends NewVehicleDTO, VehicleDTOExtension {}
